export let OperatorValue = [
  0, // EQ
  1, // LE
  2, // GE
  3, // LT
  4, // GT
];

export let Operators = [
  "=", //
  "<=", //
  ">=", //
  "<", //
  ">", //
];

export function GetOperatorValue(operator) {
  let value;

  switch (operator) {
    case Operators[0]:
      value = OperatorValue[0];
      break;
    case Operators[1]:
      value = OperatorValue[1];
      break;
    case Operators[2]:
      value = OperatorValue[2];
      break;
    case Operators[3]:
      value = OperatorValue[3];
      break;
    case Operators[4]:
      value = OperatorValue[4];
      break;

    default:
      value = OperatorValue[0];
      break;
  }

  value = value.toString(16).toUpperCase();

  if (value.length == 1) {
    value = "0" + value;
  }

  return value;
}

export function GetOperatorName(operator) {
  switch (operator) {
    case OperatorValue[0]:
      return Operators[0];
    case OperatorValue[1]:
      return Operators[1];
    case OperatorValue[2]:
      return Operators[2];
    case OperatorValue[3]:
      return Operators[3];
    case OperatorValue[4]:
      return Operators[4];

    default:
      return Operators[0];
  }
}
